import AdDetails from "./AdDetails";
import Confirm from "./Confirm";

export default {
  AD_DETAILS: AdDetails,
  CONFIRM: Confirm,
};
